import type { Ref } from 'vue';
import { computed } from 'vue';
import { useCountdownTimer } from '@/composable/useCountdownTimer';
import { ShowTimeDisplayType } from '@/interface/enum';

interface IEventCountdown {
    showTimeType: number;
    realKickoffTime: Date;
    isLive: boolean;
}

export function useEventCountdown(
    event: Ref<IEventCountdown | null>,
) {
    const countdownEndTime = computed(() => {
        if (!event.value) {
            return new Date();
        }

        return event.value.realKickoffTime;
    });

    const { formattedTime: countdownDisplay, timeDifference } = useCountdownTimer(countdownEndTime);

    const isShowCountdownHours = computed(() => countdownDisplay.value.hours !== '00');

    const isShowCountdown = computed(() => {
        if (!event.value) {
            return false;
        }

        if (event.value.showTimeType === ShowTimeDisplayType.Date) {
            return false;
        }

        if (event.value.isLive) {
            return false;
        }

        return timeDifference.value.totalSeconds > 0;
    });

    return {
        countdownDisplay,
        isShowCountdownHours,
        timeDifference,
        isShowCountdown,
    };
}
